import { authClient } from '../auth';

export function authRequestInterceptor(instance: any) {
    instance.interceptors.request.use(addAuthorizationHeader, (error: Error) => Promise.reject(error));
}

function addAuthorizationHeader(request: any) {
    // Vladan Radovanovic 2025.10.02 - move JwtToken to Cookie set by server
    // const token = authClient.getAccessToken();
    // request.headers['Authorization'] = token;
    return request;
}
